import clsx from 'clsx'
import {React, useCallback, useContext, useEffect, useState} from 'external/react'
import {useHistory} from 'react-router-dom'
import {makeStyles, Dialog, DialogTitle, DialogContent, Box, Button} from 'external/material'
import fetch from 'helpers/command'
import {TeacherContext} from 'teacher/context'
import StandardsSelector from 'components/standards-selector/components/StandardsSelector'
import {selectedItems} from 'components/standards-selector/domain/selection.cjs'

const useStyles = makeStyles(createStyles)
const useDialogStyles = makeStyles(createDialogStyles)

export default function AddStandards ({open, backPath, onSaveStandards}) {
  const classes = useStyles()
  const dialogClasses = useDialogStyles()
  const history = useHistory()
  const {translate, standardsContext, updateState, query, languageId} = useContext(TeacherContext)
  const [filters, setFilters] = useState(query)
  const [selected, setSelected] = useState(standardsContext.selectStandards.selected || {})

  useEffect(() => {
    if (open) {
      setFilters(query)
      setSelected(standardsContext.selectStandards.selected || {})
    }
  }, [open])

  const load = useCallback((entity, parameters) => fetch('de', entity)({language: languageId, ...parameters}), [languageId])

  async function closeDialog () {
    await updateState({standardsContext: {selectStandards: {selected: {$set: {}}, questionStandards: {$set: {}}}}})
    history.push(backPath)
  }

  async function save () {
    const result = selectedItems(selected)
    await closeDialog()
    if (onSaveStandards) await onSaveStandards(result)
  }

  return <Dialog classes={dialogClasses} maxWidth="md" open={open} onClose={closeDialog}>
    <DialogTitle className={classes.title}>
      <Box className={classes.titleActions}>
        <Button variant="contained" className={clsx(classes.button, 'cancel')} onClick={closeDialog}>{translate('cancel')}</Button>
        <Button variant="contained" className={clsx(classes.button, 'create')} onClick={save}>{translate('save')}</Button>
      </Box>
    </DialogTitle>
    <DialogContent className={classes.root}>
      <StandardsSelector language={languageId} load={load} mode="quiz"
        filters={filters} onFiltersChange={setFilters}
        selected={selected} onSelectionChange={setSelected}/>
    </DialogContent>
  </Dialog>
}

function createStyles () {
  return {
    root: {overflowY:'auto', flexGrow:1, minHeight:0},
    title: {borderBottom:'1px solid #ccc', marginBottom:10},
    titleActions: {display:'flex', justifyContent:'flex-end'},
    button: {
      width:120, fontSize:'13pt', textTransform:'none', boxShadow:'none', borderRadius:4,
      '&:first-child':{marginRight:10},
      '&.cancel':{border:'solid 1px #3d4556', backgroundColor:'#fff', color:'#3d4556',
        '&:hover':{color:'#000', border:'solid 1px #000', backgroundColor:'#eaf5ff'}},
      '&.create':{color:'#fff', border:'solid 1px #2c75bd', backgroundColor:'#2c75bd',
        '&:hover':{backgroundColor:'#71a7c7', borderColor:'#71a7c7', boxShadow:'none'}}
    }
  }
}

function createDialogStyles () {
  return {
    container:{display:'flex', color:'#626d88', width:'100%', height:'100%', justifyContent:'center'},
    paper:{display:'flex', flexDirection:'column', backgroundColor:'#fff', border:'solid 1px #dce1ec',
      height:'calc(100% - 120px)', minWidth:600, maxWidth:1600, borderRadius:2, width:'80%'}
  }
}
